/**
 * Copyright Mántum All Rights Reserved.
 */
import { Workbook } from 'exceljs';

export default Workbook;
